import { FC, useEffect, useState } from 'react'
import cn from './index.module.css'
import CourseCard from '../CourseCard/CourseCard'
import { Empty } from 'antd'

interface ICoursesList {
  courses: ICourse[]
}

const CoursesList: FC<ICoursesList> = ({ courses }) => {
  if (courses?.length < 1) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={'Ничего не найдено'}
      />
    )
  }

  return (
    <div className={cn.wrapper}>
      {courses?.map((course) => {
        return <CourseCard course={course} key={course.id} />
      })}
    </div>
  )
}

export default CoursesList
